import type { ReactElement } from "react";
import { Link, useSearchParams } from "react-router";

import { queryValue } from "../../app/navigation.js";

import { adminCenterUrls } from "./urls.js";

/** URL の契約 ID（<c>?tenantId=</c>。名前の大文字小文字は問わない）。1 以上の整数でなければ null。 */
export const tenantIdOf = (search: URLSearchParams): number | null => {
    const value = queryValue(search, "tenantId");
    return value !== undefined && /^[1-9]\d*$/u.test(value) ? Number(value) : null;
};

/**
 * 管理センターのサブ画面（送ったメール・アクティビティログ・課金の結果の 2 つのタブ）の戻るボタン。
 * <b>契約で絞っているとき（契約 1 件の画面から来たとき）は、その契約の画面へ戻す</b>（2026-10-10 に利用者が決めた）。
 * 絞っていなければメニューへ戻す。値は URL から読むので、断られた（400）ときも同じ行き先になる。
 */
export function CenterBackLink(): ReactElement {
    const [search] = useSearchParams();
    const tenantId = tenantIdOf(search);
    return (
        <p className="mb-4">
            {tenantId === null
                ? <Link to={adminCenterUrls.menu} className="btn-secondary btn-sm">管理センターへ戻る</Link>
                : <Link to={adminCenterUrls.tenant(tenantId)} className="btn-secondary btn-sm">管理センターの契約へ戻る</Link>}
        </p>
    );
}
